(() => {
  if (window.ougistHeroCarousels) return;
  window.ougistHeroCarousels = true;
  const initialize = (root = document) => {
    root.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';
      let slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
      const controls = carousel.querySelector('[data-hero-controls]');
      if (slides.length < 2 || !controls) return;
      const pages = Array.from(controls.querySelectorAll('[data-hero-page]'));
      // Keep manual reading uninterrupted while a pointer or keyboard is in the Hero.
      let hovered = false;
      let focused = false;
      let current = 0;
      let timer;
      const mobileViewport = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const schedule = () => {
        window.clearTimeout(timer);
        // Touch users choose when to change slides, so offers never replace a CTA mid-tap.
        if (mobileViewport.matches || reducedMotion.matches) return;
        if (!hovered && !focused && !document.hidden && slides.length > 1 && carousel.getClientRects().length) {
          timer = window.setTimeout(() => show((current + 1) % slides.length), 3000);
        }
      };
      const show = (index) => {
        current = index;
        slides.forEach((slide, i) => {
          slide.hidden = i !== current;
          slide.inert = i !== current;
          slide.setAttribute('aria-hidden', String(i !== current));
        });
        pages.forEach((page, i) => page.setAttribute('aria-current', String(i === current)));
        carousel.dataset.activeSlide = String(current + 1);
        schedule();
      };
      pages.forEach((page) => page.addEventListener('click', () => show(Number(page.dataset.heroPage))));
      carousel.addEventListener('mouseenter', () => { hovered = true; schedule(); });
      carousel.addEventListener('mouseleave', () => { hovered = false; schedule(); });
      carousel.addEventListener('focusin', () => { focused = true; schedule(); });
      carousel.addEventListener('focusout', () => {
        window.setTimeout(() => { focused = carousel.contains(document.activeElement); schedule(); }, 0);
      });
      document.addEventListener('visibilitychange', schedule);
      window.addEventListener('resize', schedule);
      reducedMotion.addEventListener('change', schedule);
      document.addEventListener('preparedness:expired', () => {
        const promotion = carousel.querySelector('[data-hero-promotion]');
        if (promotion && !promotion.querySelector('[data-preparedness-ends]')) {
          promotion.remove();
          slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
          slides[0].setAttribute('aria-label', '1 / 1');
          controls.hidden = true;
          show(0);
        }
      });
      controls.hidden = false;
      show(0);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
